import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgetPassword from "./pages/ForgetPassword";
import Dashboard from "./pages/dashboard/Dashboard";
import FAQ from "./pages/FAQ";
import ProtectedRoute from "./components/ProtectedRoute";
import VisualizeReport from "./pages/dashboard/VisualizeReport";
import EULA from "./pages/EULA";
import Privacy from "./pages/Privacy";
import Projects from "./components/Projects/Projects";
import CreateProject from "./components/Projects/CreateProject";
import ProjectSettings from "./components/Projects/ProjectSettings";
import TrendAnalysis from "./pages/dashboard/TrendAnalysis";
import GithubStats from "./pages/dashboard/GithubStats";
import NotFound from "./pages/NotFound";
import QualityGate from "./components/Projects/QualityGate";
import AnalyzeDependency from "./pages/dashboard/AnalyzeDependency";
import QualityDelta from "./pages/dashboard/QualityDelta";
import ArchitectureLayer from "./pages/dashboard/ArchitectureLayer";
import ArchitectureLayerWizard from "./pages/dashboard/ArchitectureLayerWizard";
import ArchitectureLayerCanvas from "./pages/dashboard/ArchitectureLayerCanvas";


function App() {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('Token');
    const currentPath = window.location.pathname;

    // If user has token and is on login/signup page, redirect to dashboard
    if (token && (currentPath === '/login' || currentPath === '/signup')) {
      navigate('/project/view');
    }
  }, [navigate]);
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/eula" element={<EULA />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />


        {/* Dashboard routes  */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/adhoc-code-quality-report"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/quality-trends"
          element={
            <ProtectedRoute>
              <TrendAnalysis />
            </ProtectedRoute>
          }
        />

        <Route
          path="/visualize"
          element={
            <ProtectedRoute>
              <Navigate to="/visualize/all" />
            </ProtectedRoute>
          }
        />


        <Route
          path="/visualize/:smellType"
          element={
            <ProtectedRoute>
              <VisualizeReport />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/create"
          element={
            <ProtectedRoute>
              <CreateProject />
            </ProtectedRoute>
          }
        />

        <Route
          path="/visualize/:smellType"
          element={
            <ProtectedRoute>
              <VisualizeReport />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/view"
          element={
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/analyze-dependency"
          element={
            <ProtectedRoute>
              <AnalyzeDependency />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/architecture-compliance"
          element={
            <ProtectedRoute>
              <ArchitectureLayer />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/architecture-compliance/new"
          element={
            <ProtectedRoute>
              <ArchitectureLayerWizard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/architecture-compliance/:definitionId/edit"
          element={
            <ProtectedRoute>
              <ArchitectureLayerCanvas />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/:projectId/settings"
          element={
            <ProtectedRoute>
              <ProjectSettings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/repo-insights"
          element={
            <ProtectedRoute>
              <GithubStats />
            </ProtectedRoute>
          }
        />

        <Route
          path="/github-callback"
          element={
            <ProtectedRoute>
              <GithubStats />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/:projectId/quality-gate-profile"
          element={
            <ProtectedRoute>
              <QualityGate />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/quality-delta-explorer"
          element={
            <ProtectedRoute>
              <QualityDelta />
            </ProtectedRoute>
          }
        />

        <Route
          path="/quality-delta-explorer/:smellType"
          element={
            <ProtectedRoute>
              <QualityDelta />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/:projectId/quality-gate/edit/:profileId"
          element={
            <ProtectedRoute>
              <QualityGate />
            </ProtectedRoute>
          }
        />


        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
